import { Formik, FormikHelpers } from 'formik';
import { FunctionComponent, useState } from 'react';
import { ErrorLevel, useAddError, useClearError } from '../../context/error';
import { EmptyNewTestTask, NewTestTask } from '../../interfaces/TestTask';

import { get } from 'lodash';
import { Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import BareInput from '../../components/form/BareInput';
import InputGroup from '../../components/form/InputGroup';
import InputSection from '../../components/form/InputSection';
import ToggleInput, { ToggleInputBooleanValueUndefined } from '../../components/form/ToggleInput';
import Title from '../../components/title';
import validateTestTaskInitials from '../../helpers/validate/validateTestTaskInitials';
import validateTestTaskName from '../../helpers/validate/validateTestTaskName';
import { TestTaskService } from '../../services';

const New: FunctionComponent = () => {
  const addError = useAddError();
  const clearError = useClearError();

  const navigate = useNavigate();

  const [item] = useState<NewTestTask>(EmptyNewTestTask);

  const onSubmit = async (values: NewTestTask, { setSubmitting }: FormikHelpers<NewTestTask>) => {
    setSubmitting(true);
    clearError();
    try {
      const id = await TestTaskService(addError).create(values);
      if (id && id > 0) {
        navigate(`/settings/tasks/${id}`);
      }
    } catch (error) {
      addError({
        level: ErrorLevel.danger,
        message: get(error, 'message', 'Unbekannter Fehler'),
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik enableReinitialize={true} initialValues={item} onSubmit={onSubmit}>
      {({ handleSubmit, isValidating, isValid, errors, isSubmitting, touched }) => (
        <form autoComplete="off" onSubmit={handleSubmit}>
          <Title
            onCancel={() => {
              navigate('..');
            }}
            editing={true}
            editingValid={!isValidating && isValid && Object.keys(touched).length > 0}
            isSubmitting={isSubmitting}
            title={'Neue Prüfart'}
          />
          <Row>
            <InputSection title="Stammdaten" xs={12} xl={6}>
              <InputGroup error={errors.name} valid={!errors.name} title="Name" name="name">
                <BareInput disabled={isSubmitting} type="text" name="name" validate={validateTestTaskName} />
              </InputGroup>
              <InputGroup error={errors.initials} valid={!errors.initials} title="Kürzel" name="initials">
                <BareInput disabled={isSubmitting} type="text" name="initials" validate={validateTestTaskInitials} />
              </InputGroup>
              <InputGroup error={errors.norm} valid={!errors.norm} title="Norm" name="norm">
                <BareInput disabled={isSubmitting} type="norm" name="norm" />
              </InputGroup>
              <InputGroup
                error={errors.withoutTestingDevice}
                valid={!errors.withoutTestingDevice}
                title="Ohne Prüfmittel"
                name="withoutTestingDevice"
              >
                <ToggleInput
                  validate={(value: any) => value === ToggleInputBooleanValueUndefined}
                  name="withoutTestingDevice"
                  disabled={isSubmitting}
                />
              </InputGroup>
            </InputSection>
          </Row>
        </form>
      )}
    </Formik>
  );
};

export default New;
